(ns cms.editor.core
  (:require 
    [cms.fetch :refer [fetch]]
    [clojure.string :as str]
    [common.util :refer [new-uuid]]
    [firebase.functions :as fns]
    [promises.core :refer-macros [await->]]
    [reagent.core :as r]))

(defonce search& (r/atom nil))

(defmulti schema-editor 
  (fn [url defs schema node&]
    (let [target-type (get-in schema ["properties" "Type" "const"]
                              (get schema "type"))]
      (keyword target-type))))

(defn apply-filter [nodes]
  (if @search&
    (let [search 
          (str/lower-case @search&)
          
          result 
          (->> nodes 
           (filter 
             (fn [[k {:strs [Title Artist]}]]
               (->> [k Title Artist]
                    (remove str/blank?)
                    (map str/lower-case)
                    (some #(str/includes? % search)))))
           (into {}))]
      result)
    nodes))

(defn resolve-schema [defs schema]
  (if-let [$ref (get schema "$ref")]
    (let [path (re-seq #"[^\#/]+" $ref)
          resolved (get-in defs path)]
      resolved)
    schema))

(defn schema-in [defs schema path]
  (resolve-schema defs (get-in schema path)))

(defn- schema->enum [schema]
  (or 
    (get schema "enum")
    (when-let [const (get schema "const")]
      [const])))


(defn populate [defs schema]
  (let [s (resolve-schema defs schema)]))


(defn schema-complexity [[key schema]]
  (let [t (get schema "type")
        
        expands? 
        (or (contains? schema "additionalProperties")
            (contains? schema "items"))
        
        complexity
        (case [t expands?] 
          ["array" false]  1 
          ["object" false] 2
          ["array" true]   3
          ["object" true]  4
          0)]
    complexity))

(def property-order
  (memoize 
    (fn [props]
      (sort-by (juxt schema-complexity first) props))))

(defn property-editors [_ _ _ _]
  (fn [url defs props node&]
    [:table  
     (into [:tbody]
           
           (for [[prop subschema] 
                 (property-order props)]
             
             (let [sub-url (str url "/" prop)
                   sub-editor 
                   (schema-editor 
                     sub-url defs 
                     (resolve-schema defs subschema) 
                     (r/cursor node& [prop]))]
               
               (when sub-editor 
                 [:tr {:key prop} 
                  [:th [:a {:href (str "#/edit/" sub-url)} prop]]
                  [:td sub-editor]]))))]))

(defmethod schema-editor :default [url defs schema node&]
  (let [type (get-in schema ["properties" "Type" "const"])
        {:strs [title description]} schema
        props (set (get schema "properties"))
        addt (resolve-schema defs (get schema "additionalProperties"))]
    (println "render " url)
    [:div.column
     (when title 
       [:div.column
        {:style {:gap "4px"
                 :margin-bottom "8px"}} 
        [:h5 title]
        [:p.deemph description]])
     (when (seq props)
       [property-editors url defs props node&])     
     (when addt
       [:details 
        {:open true}
        [:summary [:span.deemph (str "(" (count @node&) " items)")]]
        [:table
         {:class type}
         [:tbody    
          [:tr 
           {:on-click 
            (fn [_]
              (when-let [new-key (js/prompt "Enter new primary key" (new-uuid))]                   
                (swap! node& assoc  
                       new-key
                       (populate defs addt))
                (set! (.. js/window -location -hash)
                      (str "#/edit/" url "/" new-key))))}
           [:td [:button "➕"]]
           [:td.deemph 
            [:a 
             (str "Click to add a " (get addt "title" (get addt "type")))]]]
          
          (let 
            [additional-props
             (remove (fn [[key _]] (contains? props key))
                     @node&)
             
             filtered-props
             (apply-filter additional-props)]
            
            (conj 
              (into 
                [:<>] 
                (for [[prop value] filtered-props]
                  (let [sub-url (str url "/" prop)]
                    [:tr {:key prop}
                     [:th 
                      [:a {:href (str "#/edit/" sub-url)} prop]]
                     [:td [schema-editor
                           sub-url
                           defs addt
                           (r/cursor node& [prop])]]
                     [:td 
                      [:button 
                       {:on-click #(swap! node& dissoc prop)}
                       "🗑"]]])))
              
              (when @search& 
                (let [total (count additional-props)
                      filtered (count filtered-props)]
                  (if (< filtered total)
                    [:tr 
                     [:td {:colspan 2}
                      [:div.deemph
                       {:style {:justify-content :center
                                :gap "1ch"}}
                       (str (- total filtered) " items hidden by filter '" @search& "'.")
                       [:a
                        {:on-click 
                         (partial reset! search& nil)} 
                        "Clear filter."]]]])))))]]])]))

